
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import isObject$1 from './is-object.js';

var isObject = isObject$1;

var isPossiblePrototype = function (argument) {
  return isObject(argument) || argument === null;
};

export { isPossiblePrototype as default };
//# sourceMappingURL=is-possible-prototype.js.map
